<template>
  <TextUpload
    :titleUpload="titleUpload"
    :subtitletUpload="subtitleUpload"
  />
  <CardUploadStatus
    v-for="(file, i) in vehicleFileDetails" :key="i"
    :isVisibleTitleCard="file.statusUpload != 'Success'"
    :titleCard="file.cardName"
    :isVisibleTitle="file.statusUpload == 'Success'"
    :titleFile="file.cardName"
    :subtitleFile="file.fileName"
    :isError="file.statusUpload == 'Error'"
    :isVisibleStatus="file.statusUpload != 'Success'"
    :status="'0'"
    :isVisibleIconFile="file.statusUpload != 'Success'"
    :isVisibleIconCheck="file.statusUpload == 'Success'"
    :isVisibleIconArrow="file.statusUpload == 'Error'"
    :isVisibleIconTrash="file.statusUpload != 'Error'"
    @try-again-click="handleTryAgainClick(file.routeNameComponent)"
  />
  <FooterButton :confirmData="confirmData" :isDisabled="isAnyUploadInProgress"/>
</template>

<script>
  import CardUploadStatus from '@/cadastro/components/CardUploadStatus.vue';
  import FooterButton from '../../components/FooterButton.vue';
  import TextUpload from '@/cadastro/components/TextUpload.vue';
  import { useStore } from '@/stores/cadastro';
  import { useRouter } from 'vue-router';
  import axios from 'axios';
  import Swal from 'sweetalert2';
  import { computed } from 'vue';

  export default {
    components: {
      CardUploadStatus,
      FooterButton,
      TextUpload
    },
    setup() {
      const store = useStore();
      const router = useRouter();

      const confirmData = async () => {
        const data = store.getVehicleData;
        data.registration_steps = { vehicle_data: true };
        const driverId = store.getDriverId;

        try {
          const response = await axios.post(`/cadastro-motorista/update/${driverId}`, {
            data: data
          });
          if (response.data && response.data.id) {
            store.setDriverId(response.data.id);
          }
          Swal.fire({
            title: 'Dados enviados com sucesso!',
            text: 'Os dados do seu veículo foram salvos, por favor informe o restante dos dados nos passos seguintes.',
            icon: 'success',
            allowOutsideClick: false,
            timer: 10000,
            timerProgressBar: true,
            showConfirmButton: true,
            confirmButtonText: 'Ok'
          }).then(() => {
            if (response.status == 200) {
              router.push({ name: 'StatusRegistration' });
            }
          });
        } catch (error) {
            console.error('Erro inesperado:', error);
            Swal.fire({
              title: 'Ops...',
              text: 'Erro inesperado, por favor tente novamente mais tarde.',
              icon: 'error',
              confirmButtonText: 'Ok'
            });
        }
      };

      const vehicleFiles = computed(() => store.getVehicleFile);
      const vehicleFileDetails = computed(() =>
        Object.values(vehicleFiles.value).map(file => ({
          cardName: file.cardName,
          routeNameComponent: file.routeNameComponent,
          fileName: file.fileName,
          statusUpload: file.statusUpload
        }))
      );

      const isAnyUploadInProgress = computed(() => 
          vehicleFileDetails.value.some(file => file.statusUpload !== 'Success')
        );

      const titleUpload = computed(() => {
        if (vehicleFileDetails.value.some(file => file.statusUpload === 'Error')) {
          return 'Upload com falha!';
        } else if (vehicleFileDetails.value.every(file => file.statusUpload === 'Success')) {
          return 'Temos suas fotos!';
        } else {
          return 'Upload em andamento!';
        }
      });

      const subtitleUpload = computed(() => {
        if (vehicleFileDetails.value.some(file => file.statusUpload === 'Error')) {
          return 'Um ou mais uploads falharam. Por favor, tente novamente.';
        } else if (vehicleFileDetails.value.every(file => file.statusUpload === 'Success')) {
          return 'Suas informações foram salvas com sucesso.';
        } else {
          return 'Há uploads em andamento. Por favor, aguarde.';
        }
      });

      return {

        confirmData,
        vehicleFileDetails,
        isAnyUploadInProgress,
        titleUpload,
        subtitleUpload,
        store
      };
    },
    methods: {
      handleTryAgainClick(routeNameComponent) {
        const correspondingRoute = this.getCorrespondingRoute(routeNameComponent);
     
        this.store.updateVehicleFile(routeNameComponent, false)

        if (correspondingRoute == 'VehicleFront') {
          this.$router.push({ name: correspondingRoute, query: { currentStep: 2} });
        } else {
          this.$router.push({ name: correspondingRoute });
        }
      },
      getCorrespondingRoute(routeNameComponent) {
        const routeMap = {
          'vehicle_front': 'VehicleFront',
          'vehicle_back': 'VehicleBack',
          'vehicle_trunk': 'VehicleTrunk',
          'vehicle_side': 'VehicleSide',
        };
        return routeMap[routeNameComponent];
      }
    }
  }
</script>
